import { WeaveIdleDetector } from './IdleDetector';

/**
 * Shared singleton IdleDetector instance for all Flow instances.
 * This prevents DOM listener explosion by having a single detector
 * that all flows subscribe to.
 */
export const sharedIdleDetector = new WeaveIdleDetector({
  threshold: 30_000,
  debug: false,
});
